<template>
    <div v-if="operationType === operationTypeEnum.GIFT || operationType === operationTypeEnum.BORROWING">
        <Listbox :options="myBooks" optionLabel="title" style="text-align: center;" />
    </div>
    <div v-if="operationType === operationTypeEnum.EXCHANGE" dir="rtl">
        <div>{{ $t('MY_BOOKS') }}</div>
        <Listbox :options="myBooks" optionLabel="title" style="text-align: center;" />
        <div style="margin-top: 2em;">{{ $t('OTHER_BOOKS') }}</div>
        <Listbox :options="otherBooks" optionLabel="title" style="text-align: center;" />
    </div>
</template>

<script setup>
import { ref, onBeforeMount, inject } from 'vue'
import { operationTypeEnum } from '@/helpers/Constants'

const dialogRef = inject("dialogRef")
const myBooks = ref([])
const otherBooks = ref([])
const operationType = ref()

onBeforeMount(() => {
    myBooks.value = dialogRef.value.data.myBooks
    otherBooks.value = dialogRef.value.data.otherBooks
    operationType.value = dialogRef.value.data.operationType
})
</script>

<style></style>